// header.js
import React, { useEffect, useMemo, useState } from "react";

import {
  PeriodeProvider,
  usePeriode,
} from "../landing_page/context/PeriodeContext";

import Map from "./summary/Map";
import ReportPrimer from "./summary/reportprimer";
import ReportPasca from "./summary/reportpasca";
import ReportSmkhp from "./summary/reportsmkhp";

import "../landing_page/styles/landing.css";

const HeaderContent = () => {
  const { periode, setPeriode } = usePeriode();
  const { startDate, endDate } = periode;

  const currentYear = new Date().getFullYear();

  const yearOptions = Array.from(
    { length: 6 },
    (_, index) => currentYear - index
  );

  const selectedYear = String(
    startDate || `${currentYear}-01-01`
  ).split("-")[0];

  // =========================================================
  // FILTER PERIODE GLOBAL
  // =========================================================
  const handleYearChange = (e) => {
    const year = e.target.value;

    setPeriode({
      startDate: `${year}-01-01`,
      endDate: `${year}-12-31`,
    });
  };

  // =========================================================
  // REPORT
  // =========================================================
 const reports = useMemo(
  () => ({
    primer: {
      label: "PRIMER",
      Component: ReportPrimer,
    },

    pasca: {
      label: "PASCA PANEN",
      Component: ReportPasca,
    },

    smkhp: {
      label: "SMKHP",
      Component: ReportSmkhp,
    },
  }),
  []
);

  const reportKeys = useMemo(
    () => Object.keys(reports),
    [reports]
  );

  const [activeReport, setActiveReport] = useState(
    reportKeys.length > 0 ? reportKeys[0] : null
  );

  // =========================================================
  // AUTO SLIDE REPORT
  // =========================================================
  useEffect(() => {
    if (reportKeys.length <= 1) return undefined;

    const timer = setInterval(() => {
      setActiveReport((current) => {
        const currentIndex = reportKeys.indexOf(current);

        if (currentIndex === -1) {
          return reportKeys[0];
        }

        const nextIndex =
          (currentIndex + 1) % reportKeys.length;

        return reportKeys[nextIndex];
      });
    }, 10000);

    return () => clearInterval(timer);
  }, [reportKeys]);

  return (
    <header
      id="header"
      style={{
        paddingTop: "90px",
      }}
    >
      <div className="container-fluid px-3">

        {/* =====================================================
            HEADER PETA + FILTER PERIODE
        ====================================================== */}
        <div
          className="
            d-flex
            flex-column
            flex-lg-row
            justify-content-between
            align-items-lg-center
            gap-3
            mb-3
          "
          style={{
            background: "rgba(255,255,255,0.96)",
            backdropFilter: "blur(12px)",
            WebkitBackdropFilter: "blur(12px)",
            border: "1px solid rgba(226,232,240,0.95)",
            borderRadius: "16px",
            padding: "14px 20px",
            boxShadow:
              "0 4px 16px rgba(15,23,42,0.10)",
            position: "relative",
            zIndex: 10,
          }}
        >
          <div
            className="d-flex align-items-center"
            style={{
              gap: "13px",
              minWidth: 0,
              flex: 1,
            }}
          >
            {/* GARIS BIRU */}
            <div
              style={{
                width: "5px",
                height: "42px",
                background: "#1769ff",
                borderRadius: "10px",
                flexShrink: 0,
              }}
            />

            <div
              style={{
                minWidth: 0,
              }}
            >
              <div
                style={{
                  fontSize: "16px",
                  fontWeight: 800,
                  color: "#1e293b",
                  lineHeight: 1.25,
                  letterSpacing: "-0.2px",
                }}
              >
                PETA SEBARAN UPT DAN PENERBITAN SERTIFIKASI MUTU
              </div>

              <div
                className="d-flex flex-wrap align-items-center gap-2 mt-1"
                style={{
                  fontSize: "12px",
                }}
              >
                <span
                  style={{
                    fontWeight: 800,
                  }}
                >
                  <span style={{ color: "#1268ff" }}>
                    BPP
                  </span>
                  <span style={{ color: "#ff7a00" }}>
                    MHKP
                  </span>
                </span>

                {/* <span
                  style={{
                    color: "#cbd5e1",
                  }}
                >
                  •
                </span> */}

                {/* <span
                  style={{
                    color: "#64748b",
                    fontWeight: 600,
                  }}
                >
                  Periode {startDate} s.d. {endDate}
                </span> */}
              </div>
            </div>
          </div>

          <div
            className="d-flex align-items-center gap-3"
            style={{
              borderLeft: "1px solid #e2e8f0",
              paddingLeft: "20px",
              flexShrink: 0,
            }}
          >
            <div>
              <div
                style={{
                  fontSize: "9px",
                  fontWeight: 800,
                  color: "#94a3b8",
                  letterSpacing: "0.6px",
                  lineHeight: 1.2,
                  marginBottom: "2px",
                }}
              >
                PERIODE DATA
              </div>

              <div
                style={{
                  fontSize: "11px",
                  fontWeight: 700,
                  color: "#475569",
                  whiteSpace: "nowrap",
                }}
              >
                PILIH TAHUN
              </div>
            </div>

            <select
              aria-label="Pilih tahun dashboard"
              value={selectedYear}
              onChange={handleYearChange}
              style={{
                height: "40px",
                minWidth: "100px",
                padding: "0 14px",
                borderRadius: "12px",
                border: "1px solid #dbe4f0",
                background: "#eff6ff",
                color: "#1769ff",
                fontSize: "14px",
                fontWeight: 800,
                outline: "none",
                cursor: "pointer",
                boxShadow:
                  "0 1px 3px rgba(15,23,42,0.12)",
              }}
            >
              {yearOptions.map((year) => (
                <option
                  key={year}
                  value={year}
                >
                  {year}
                </option>
              ))}
            </select>
          </div>
        </div>
      
        <div className="header-map">
          <Map />
        </div>

         <section className="certificate-section">

          {/* HEADER REPORT */}
          <div className="certificate-summary-header p-3">
            <div className="certificate-title">
              <span className="me-2">
                JUMLAH PENERBITAN SERTIFIKASI
              </span>

              {Object.entries(reports).map(
                ([key, report]) => (
                  <button
                    key={key}
                    type="button"
                    onClick={() =>
                      setActiveReport(key)
                    }
                    className={`certificate-tab ${
                      activeReport === key
                        ? "active"
                        : ""
                    }`}
                  >
                    {report.label}
                  </button>
                )
              )}
            </div>
          </div>

          {/* CONTENT REPORT */}
         <div className="certificate-summary">
          <div className="certificate-content">
            {Object.entries(reports).map(
              ([key, report]) => {
                const ReportComponent =
                  report.Component;

                return (
                  <div
                    key={key}
                    className="certificate-running"
                    style={{
                      display:
                        activeReport === key
                          ? "block"
                          : "none",
                    }}
                  >
                    <ReportComponent />
                  </div>
                );
              }
            )}
          </div>
        </div>
        </section>
      </div>
    </header>
  );
};

const Header = () => {
  return (
    <PeriodeProvider>
      <HeaderContent />
    </PeriodeProvider>
  );
};

export default Header;